/**
 * @packageDocumentation
 * @module f1/to
 */

const typePrefix = '[object '.length;

export interface ToType {
  /**
   * Convert an object to a type string
   *
   * @public
   * @function f1.to.type
   * @example
   *
   * ```ts
   * f1.to.type(new Date()) === 'Date'
   * f1.to.type(/works/) === 'RegExp'
   * f1.to.type([]) === 'Array'
   * f1.to.type({}) === 'Object'
   * f1.to.type(new Error('error')) === 'Error'
   * f1.to.type(Promise.resolve('')) === 'Promise'
   *
   * class Test {}
   * const test = new Test();
   *
   * f1.to.type(test) => 'Test'
   * ```
   */
  (v: unknown): string;
}

/**
 * @see ToType
 */
export default (v: unknown): string => {
  return v && typeof v === 'object' && v.constructor != null
    ? v.constructor.name
    : Object.prototype.toString.call(v).slice(typePrefix, -1);
};
